export const STR = {
  en: {
    metaTitle: "Pranjal Sir Physics | Online NEET, JEE & Board Mentorship",
    metaDesc: "Learn Physics with Pranjal Dwivedi through personalized online one-to-one sessions and small-group mentorship for NEET, JEE, and Class 11–12 board examinations.",
    nav: { about: "About", programs: "Programs", method: "How it works", faq: "FAQs", demo: "Book a free demo" },
    heroEyebrow: "PERSONALIZED ONLINE MENTORSHIP",
    heroLines: ["Understand Physics.", "Build confidence.", "Achieve your goals."],
    heroLeadA: "Your Physics mentor for NEET, JEE and Class 11–12 boards — with a learning plan built around ",
    heroLeadYou: "you.",
    heroDemo: "Book your free demo",
    testCta: "Take the Free Physics Test",
    hwCta: "Daily Homework",
    hwBadge: "10 FRESH Qs · MON–SAT",
    planCta: "Make My Study Timetable",
    callCta: "Talk to Pranjal Sir's Team",
    callNote: "1-to-1 in seconds",
    heroPrograms: "Explore programs",
    heroNote: "Tell us your academic goals. We’ll help you find the right learning path.",
    liveBadge: "Live 1:1 mentorship",
    trust: [
      { big: "10+", lines: ["years teaching", "experience"] },
      { icon: "users", lines: ["Personal attention", "over crowded rooms"] },
      { icon: "target", lines: ["NEET · JEE ·", "CBSE / ICSE"] },
      { icon: "compass", lines: ["Clear plan.", "Steady progress."] },
    ],
    marquee: ["NEET PHYSICS", "JEE MAIN & ADVANCED", "CLASS 11–12 BOARDS", "ONE-TO-ONE MENTORSHIP", "CONCEPT CLARITY", "NUMERICAL MASTERY", "SMALL-GROUP CLASSES", "DOUBT SOLVING"],
    barrierEyebrow: "THE PHYSICS BARRIER",
    barrierH2: { a: "More lectures aren't", em: "always", b: " the answer." },
    barrierP: "When Physics feels stuck, the missing piece is often not more content. It’s a mentor who sees exactly where you are.",
    challenges: [
      ["Concepts feel unclear", "I understand the theory in class but struggle to apply it to questions."],
      ["Doubts pile up", "I have questions but do not always get enough time to ask them."],
      ["Numericals feel impossible", "I know the formulas but cannot identify the correct approach."],
      ["Confidence takes a hit", "Physics feels difficult, and I lack confidence while solving problems."],
      ["No personal attention", "I need someone to understand my weaknesses and guide me individually."],
      ["Exam preparation is stressful", "I need a structured plan for boards, NEET, or JEE."],
    ],
    quoteA: "You do not always need more lectures.",
    quoteB: "Sometimes, you need the right mentor.",
    quoteCta: "Find your learning plan",
    aboutEyebrow: "YOUR MENTOR",
    aboutH2: { a: "Meet Er. Pranjal", em: "Dwivedi Sir." },
    aboutLead: "Physics Educator · NEET & JEE Mentor · Online One-to-One Tutor",
    aboutP1: "Er. Pranjal Dwivedi is a Physics educator with over ten years of teaching experience. His approach focuses on conceptual clarity, logical thinking, numerical problem-solving, and understanding the reasoning behind Physics concepts.",
    aboutP2: "Through personalized online mentorship, he identifies learning gaps, addresses doubts directly, and helps students develop confidence — one clear concept at a time.",
    principles: ["Concept before formula", "Understanding before memorization", "Practice with purpose"],
    aboutCta: "Learn with Pranjal Sir",
    badgeLines: ["YEARS OF", "TEACHING"],
    programsEyebrow: "MENTORSHIP PROGRAMS",
    programsH2: { a: "Choose your way", b: "to learn ", em: "better." },
    programsP: "Different goals need different kinds of support. Find the format that fits where you are right now.",
    programs: [
      { tag: "01 / EXAM FOCUS", title: "NEET Physics", copy: "Build conceptual understanding, numerical accuracy, and a reliable exam preparation rhythm.", items: ["Live online sessions", "NEET-level question practice", "Revision and practice planning", "Individual doubt-solving"] },
      { tag: "02 / DEEP THINKING", title: "JEE Physics", copy: "Strengthen fundamentals and learn to approach challenging questions with clarity and logic.", items: ["Concept-focused live sessions", "Main & Advanced pathways", "Problem-solving strategies", "Personalized practice plans"] },
      { tag: "03 / FOUNDATIONS", title: "Class 11–12 Boards", copy: "Make every chapter feel structured, understandable, and ready for board-style questions.", items: ["Chapter-wise explanations", "Derivations and numericals", "Revision sessions", "Personalized academic support"] },
      { tag: "04 / MOST PERSONAL", title: "One-to-One Mistake Analysis", copy: "A video session where Pranjal Sir goes through YOUR test and homework mistakes — shows exactly what you're doing wrong and how to raise your marks.", items: ["Your mistakes, analysed line by line", "Find exactly where marks leak", "Personal plan to raise your score", "Direct interaction with Pranjal Sir"] },
    ],
    featuredLabel: "Recommended",
    programCta: "Explore program",
    pricingNote: "Fees, session duration and frequency are discussed after understanding your learning goals.",
    methodEyebrow: "THE STARTING POINT",
    methodH2: { a: "One conversation.", em: "Four clear steps." },
    methodP: "No pressure, no promises of impossible results. Just an honest conversation about where you are and what might help.",
    steps: [
      ["Tell us about yourself", "Share your class, exam target, and what you need help with."],
      ["Discuss your goals", "We’ll understand your preparation level and preferred format."],
      ["Attend a demo session", "Experience the teaching approach before you decide."],
      ["Start your journey", "Choose a suitable program after discussing availability."],
    ],
    demoEyebrow: "TEACHING DEMO",
    demoH2: { a: "Experience the teaching", b: "before you ", em: "decide." },
    demoP: "Watch a real lecture below — or book a demo session straight away.",
    demoCta: "Book a conversation",
    lecturesEyebrow: "VIDEO LIBRARY",
    lecturesH2: { a: "Watch the teaching,", b: "binge the ", em: "concepts." },
    lecturesP: "Handpicked lectures from the Pranjal Sir Physics channel — watch anytime, as many times as you need.",
    lecturesChannel: "Browse the full YouTube channel ↗",
    enquiryEyebrow: "LET’S TALK PHYSICS",
    enquiryH2: { a: "Let’s understand", b: "your ", em: "goals." },
    enquiryP: "Share a few details and our team will contact you to discuss a suitable mentorship program and demo availability.",
    waNote: "Prefer WhatsApp?",
    waCta: "Chat with the team directly ↗",
    form: {
      title: "Tell us a little about yourself",
      req: "Fields marked * are required.",
      name: "Student full name *",
      mobile: "Mobile number *",
      whatsapp: "WhatsApp number *",
      sameNumber: "Same as mobile number",
      currentClass: "Current class *",
      targetExam: "Target examination *",
      format: "Learning format *",
      challenge: "Main Physics challenge *",
      contactTime: "Preferred contact time *",
      message: "Your message",
      phName: "Your name",
      phPhone: "10-digit number",
      phMessage: "Tell us what you need help with...",
      selectClass: "Select class",
      classOptions: [["Class 11", "Class 11"], ["Class 12", "Class 12"], ["Dropper", "Dropper"], ["Other", "Other"]],
      selectExam: "Select exam",
      examOptions: [["NEET", "NEET"], ["JEE Main", "JEE Main"], ["JEE Advanced", "JEE Advanced"], ["CBSE Boards", "CBSE Boards"], ["ICSE/ISC Boards", "ICSE/ISC Boards"], ["Other", "Other"]],
      selectFormat: "Select format",
      formatOptions: [["One-to-One Online Sessions", "One-to-One Online Sessions"], ["Small-Group Classes", "Small-Group Classes"], ["Need Guidance", "Need Guidance"]],
      selectChallenge: "Select challenge",
      challengeOptions: [["Weak Concepts", "Weak Concepts"], ["Difficulty Solving Numericals", "Difficulty Solving Numericals"], ["Doubt-Solving Support", "Doubt-Solving Support"], ["Board Examination Preparation", "Board Examination Preparation"], ["NEET/JEE Preparation", "NEET/JEE Preparation"], ["Overall Physics Improvement", "Overall Physics Improvement"]],
      selectTime: "Select a time",
      timeOptions: [["Morning", "Morning"], ["Afternoon", "Afternoon"], ["Evening", "Evening"]],
      consent: "I agree that the Pranjal Sir Physics team may contact me regarding this enquiry.",
      submit: "Request my free demo",
      sending: "Sending your enquiry…",
      privacy: "Your information is used only to respond to your enquiry and arrange counselling. No appointment is confirmed automatically.",
      errPhone: "Please enter valid 10-digit Indian mobile and WhatsApp numbers.",
      errConsent: "Please confirm that we may contact you about this enquiry.",
      errGeneric: "Something went wrong. Your details are still here — please try again.",
    },
    success: { eyebrow: "ENQUIRY RECEIVED", title: "Thank you for your interest.", body: "Your enquiry has been received. Our team will contact you to discuss your learning requirements and demo availability.", ref: "Your reference", wa: "Chat on WhatsApp" },
    faqEyebrow: "QUESTIONS, ANSWERED",
    faqH2: { a: "Good to know", b: "before you ", em: "begin." },
    faqItems: [
      ["Who can join Pranjal Sir Physics mentorship?", "Students preparing for NEET, JEE, and Class 11–12 board examinations can enquire about suitable programs."],
      ["Are the classes conducted online?", "Yes. The mentorship programs are designed around live online learning."],
      ["What is a one-to-one Physics session?", "It is an individual online session focused on one student’s questions, concepts, and learning needs."],
      ["Are small-group classes available?", "Selected programs may offer small-group classes of approximately 5–10 students, subject to availability."],
      ["Can I book a demo before enrolling?", "You can submit a demo request. Availability and confirmation will be communicated by the team."],
      ["What are the fees?", "Please enquire for current program details and pricing."],
      ["Do you teach both NEET and JEE Physics?", "Please enquire for current program details and pricing."],
      ["Can I get help with a specific Physics chapter?", "Please enquire for current program details and pricing."],
    ],
    closingEyebrow: "YOUR NEXT CHAPTER",
    closingH2: { a: "Your Physics journey", b: "can start with ", em: "one conversation." },
    closingP: "Whether you’re preparing for NEET, JEE, or boards, the first step is understanding where you need help.",
    closingCta: "Book your free demo",
    footerTag: "Personalized Physics mentorship for students who want to understand, not just memorize.",
    footerAbout: "About",
    footerPrograms: "Programs",
    footerContact: "Contact",
    rights: "© 2026 Pranjal Sir Physics. All rights reserved.",
    legal: "Privacy · Terms · Cancellation policy",
    classroomEyebrow: "BEYOND THE SCREEN",
    classroomH2: { a: "Real classrooms.", b: "Real ", em: "students." },
    classroomP: "Alongside online mentorship — classroom sessions, Doubt Club meetups and seminars in Lucknow.",
    classroomCaps: ["Student wins, celebrated together", "Classroom sessions in full flow", "Seminars & doubt-solving meetups"],
    instagramCta: "Follow @pranjal_physics on Instagram ↗",
    resultsEyebrow: "PROOF, NOT PROMISES",
    resultsH2: { a: "Selected aspirants.", b: "Real ", em: "ranks." },
    resultsP: "Every selection here began with one honest conversation and steady, personal mentorship.",
    meterTitle: "STUDENTS MENTORED SO FAR",
    meterNote: "across NEET, JEE & board batches",
    meterSuffix: "…and counting",
    programWa: (title) => `Hello Pranjal Sir! I'm interested in the ${title} program. Please share the fees, timings and demo details.`,
    selectedBadge: "SELECTED",
    results: [
      { img: "/result-surya.jpg", name: "Surya Pratap Singh", detail: "KGMU 2026 · AIR 2000 · NEET", pos: "center 72%" },
      { img: "/result-krish.jpg", name: "Krish Verma", detail: "Selected to KGMC · NEET", pos: "center 64%" },
    ],
    clips: [
      { src: "/clip-1.mp4", cap: "Live lecture — concepts on the big board" },
      { src: "/clip-2.mp4", cap: "Hands-on Physics — lab demonstration" },
      { src: "/clip-3.mp4", cap: "Inside our classroom sessions" },
    ],
    counters: [
      { to: 500, suffix: "+", label: "Students mentored", sub: "across NEET, JEE & boards" },
      { to: 10, suffix: "+", label: "Years of teaching", sub: "classroom & online" },
      { text: "AIR 2000", label: "Best NEET rank", sub: "Surya Pratap Singh, 2026", gold: true },
      { to: 100, suffix: "+", label: "Medical selections", sub: "across NEET batches" },
    ],
    reviewLabel: "STUDENT REVIEW",
    testimonials: [
      { name: "Surya Pratap Singh", detail: "KGMU 2026 · AIR 2000 · NEET", quote: "प्रांजल सर से फिजिक्स पढ़कर मेरे कॉन्सेप्ट काफी अच्छे हुए हैं। पहले जो टॉपिक्स मुश्किल लगते थे, अब उन्हें समझना आसान हो गया है। सर पढ़ाने के साथ-साथ हर डाउट भी क्लियर करते हैं, जिससे फिजिक्स में मेरा कॉन्फिडेंस बढ़ा है।", quoteEn: "Studying Physics with Pranjal Sir strengthened my concepts. Topics that once felt difficult are now easy to understand. Along with teaching, he clears every doubt — that built my confidence in Physics." },
      { name: "Krish Verma", detail: "Selected to KGMC · NEET", quote: "सफलता सिर्फ अच्छे अंक लाने में नहीं, बल्कि खुद पर विश्वास रखने, लगातार मेहनत करने और कभी हार न मानने में है।", quoteEn: "Success is not just about scoring well — it is about believing in yourself, working hard consistently, and never giving up." },
    ],
    addressLabel: "VISIT THE DOUBT CLUB",
    address: "CP-33, Aliganj, Lucknow 226024",
    timingLabel: "CENTRE TIMINGS",
    timing: "10:00 AM – 8:00 PM",
    waFloat: "Chat with us",
  },
  hi: {
    metaTitle: "Pranjal Sir Physics | ऑनलाइन NEET, JEE व बोर्ड मेंटरशिप",
    metaDesc: "Er. प्रांजल द्विवेदी के साथ फिज़िक्स सीखें — NEET, JEE और कक्षा 11–12 बोर्ड के लिए व्यक्तिगत ऑनलाइन वन-टू-वन सेशन और स्मॉल-ग्रुप मेंटरशिप।",
    nav: { about: "परिचय", programs: "प्रोग्राम", method: "प्रक्रिया", faq: "सवाल-जवाब", demo: "फ्री डेमो बुक करें" },
    heroEyebrow: "व्यक्तिगत ऑनलाइन मेंटरशिप",
    heroLines: ["फिज़िक्स समझें।", "आत्मविश्वास बढ़ाएँ।", "लक्ष्य हासिल करें।"],
    heroLeadA: "NEET, JEE और कक्षा 11–12 बोर्ड के लिए आपके फिज़िक्स मेंटर — सीखने की योजना पूरी तरह ",
    heroLeadYou: "आपके अनुसार।",
    heroDemo: "फ्री डेमो बुक करें",
    testCta: "फ्री फिज़िक्स टेस्ट दें",
    hwCta: "डेली होमवर्क",
    hwBadge: "10 नए प्रश्न · सोम–शनि",
    planCta: "मेरा स्टडी टाइमटेबल बनाएं",
    callCta: "प्रांजल सर की टीम से बात करें",
    callNote: "कुछ ही सेकंड में 1-to-1",
    heroPrograms: "प्रोग्राम देखें",
    heroNote: "हमें अपने लक्ष्य बताएँ। हम आपके लिए सही रास्ता तय करने में मदद करेंगे।",
    liveBadge: "लाइव 1:1 मेंटरशिप",
    trust: [
      { big: "10+", lines: ["वर्षों का शिक्षण", "अनुभव"] },
      { icon: "users", lines: ["भीड़भाड़ वाली कक्षाओं से हटकर", "व्यक्तिगत ध्यान"] },
      { icon: "target", lines: ["NEET · JEE ·", "CBSE / ICSE"] },
      { icon: "compass", lines: ["साफ़ योजना।", "निरंतर प्रगति।"] },
    ],
    marquee: ["NEET फिज़िक्स", "JEE मेन व एडवांस्ड", "कक्षा 11–12 बोर्ड", "वन-टू-वन मेंटरशिप", "कॉन्सेप्ट क्लैरिटी", "न्यूमेरिकल महारत", "स्मॉल-ग्रुप कक्षाएँ", "डाउट सॉल्विंग"],
    barrierEyebrow: "फिज़िक्स की रुकावट",
    barrierH2: { a: "ज़्यादा लेक्चर ही", em: "हमेशा", b: " समाधान नहीं होते।" },
    barrierP: "जब फिज़िक्स अटकी लगे, तो कमी अक्सर कंटेंट की नहीं होती। कमी होती है ऐसे मेंटर की, जो ठीक-ठीक जानता हो कि आप कहाँ खड़े हैं।",
    challenges: [
      ["कॉन्सेप्ट अनस्पष्ट लगते हैं", "क्लास में थ्योरी समझ आती है, पर सवालों में लागू नहीं कर पाता।"],
      ["डाउट जमा होते जाते हैं", "सवाल तो होते हैं, पर पूछने का पर्याप्त मौका नहीं मिलता।"],
      ["न्यूमेरिकल असंभव लगते हैं", "फॉर्मूले याद हैं, पर सही अप्रोच पहचानना मुश्किल लगता है।"],
      ["आत्मविश्वास डगमगाता है", "फिज़िक्स कठिन लगती है और सवाल सॉल्व करते समय भरोसा नहीं रहता।"],
      ["व्यक्तिगत ध्यान नहीं मिलता", "मुझे कोई ऐसा चाहिए जो मेरी कमज़ोरियाँ समझे और अलग से मार्गदर्शन दे।"],
      ["परीक्षा की तैयारी तनावपूर्ण है", "बोर्ड, NEET या JEE के लिए मुझे एक ठोस योजना चाहिए।"],
    ],
    quoteA: "हमेशा ज़रूरत ज़्यादा लेक्चर की नहीं होती।",
    quoteB: "कभी-कभी ज़रूरत होती है सही मेंटर की।",
    quoteCta: "अपनी योजना खोजें",
    aboutEyebrow: "आपके मेंटर",
    aboutH2: { a: "मिलिए Er. प्रांजल", em: "द्विवेदी सर से।" },
    aboutLead: "फिज़िक्स शिक्षक · NEET व JEE मेंटर · ऑनलाइन वन-टू-वन ट्यूटर",
    aboutP1: "Er. प्रांजल द्विवेदी दस वर्षों से अधिक अनुभव वाले फिज़िक्स शिक्षक हैं। उनकी पद्धति के केंद्र में हैं कॉन्सेप्ट की स्पष्टता, तार्किक सोच, न्यूमेरिकल सॉल्व करने की क्षमता और हर कॉन्सेप्ट के पीछे की वजह समझना।",
    aboutP2: "व्यक्तिगत ऑनलाइन मेंटरशिप के ज़रिए वे सीखने की खामियाँ पहचानते हैं, डाउट सीधे दूर करते हैं और विद्यार्थियों का आत्मविश्वास बढ़ाते हैं — एक-एक स्पष्ट कॉन्सेप्ट के साथ।",
    principles: ["फॉर्मूले से पहले कॉन्सेप्ट", "रटने से पहले समझ", "उद्देश्य के साथ अभ्यास"],
    aboutCta: "प्रांजल सर के साथ सीखें",
    badgeLines: ["वर्षों का", "शिक्षण"],
    programsEyebrow: "मेंटरशिप प्रोग्राम",
    programsH2: { a: "सीखने का अपना", b: "बेहतर ", em: "तरीका चुनें।" },
    programsP: "हर लक्ष्य के लिए अलग तरह का सहारा चाहिए। अभी आप जिस मुकाम पर हैं, उसके हिसाब से सही फॉर्मेट चुनें।",
    programs: [
      { tag: "01 / परीक्षा फोकस", title: "NEET फिज़िक्स", copy: "कॉन्सेप्ट की समझ, न्यूमेरिकल सटीकता और भरोसेमंद परीक्षा-तैयारी की दिनचर्या बनाएँ।", items: ["लाइव ऑनलाइन सेशन", "NEET-स्तरीय प्रश्न अभ्यास", "रिविज़न और अभ्यास योजना", "व्यक्तिगत डाउट सॉल्विंग"] },
      { tag: "02 / गहन सोच", title: "JEE फिज़िक्स", copy: "मूलभूत बातें मज़बूत करें और चुनौतीपूर्ण सवालों को स्पष्टता और तर्क से सुलझाना सीखें।", items: ["कॉन्सेप्ट-केंद्रित लाइव सेशन", "मेन व एडवांस्ड पाथवे", "प्रॉब्लम-सॉल्विंग रणनीतियाँ", "व्यक्तिगत अभ्यास योजना"] },
      { tag: "03 / नींव", title: "कक्षा 11–12 बोर्ड", copy: "हर अध्याय को व्यवस्थित, समझने लायक और बोर्ड-पैटर्न के लिए तैयार बनाएँ।", items: ["अध्यायवार व्याख्या", "डेरिवेशन और न्यूमेरिकल", "रिविज़न सेशन", "व्यक्तिगत शैक्षणिक सहायता"] },
      { tag: "04 / सबसे व्यक्तिगत", title: "वन-टू-वन मिस्टेक एनालिसिस", copy: "एक वीडियो सेशन जिसमें प्रांजल सर आपके टेस्ट और होमवर्क की गलतियाँ देखते हैं — बताते हैं कि आपसे क्या गलत हो रहा है और मार्क्स कैसे बढ़ेंगे।", items: ["आपकी गलतियों का लाइन-बाय-लाइन विश्लेषण", "पता करें कहाँ मार्क्स कटते हैं", "स्कोर बढ़ाने की व्यक्तिगत योजना", "प्रांजल सर से सीधा संवाद"] },
    ],
    featuredLabel: "सुझाया गया",
    programCta: "प्रोग्राम देखें",
    pricingNote: "फीस, सेशन की अवधि और फ्रीक्वेंसी आपके लक्ष्य समझने के बाद तय की जाती है।",
    methodEyebrow: "शुरुआती कदम",
    methodH2: { a: "एक बातचीत।", em: "चार स्पष्ट कदम।" },
    methodP: "कोई दबाव नहीं, असंभव नतीजों के वादे नहीं। बस एक ईमानदार बातचीत — आप कहाँ हैं और क्या मदद मिल सकती है।",
    steps: [
      ["अपने बारे में बताएँ", "अपनी कक्षा, परीक्षा-लक्ष्य और किस मदद की ज़रूरत है, बताएँ।"],
      ["अपने लक्ष्य पर बात करें", "हम आपकी तैयारी का स्तर और पसंदीदा फॉर्मेट समझेंगे।"],
      ["डेमो सेशन अटेंड करें", "फैसला करने से पहले पढ़ाने का तरीका खुद अनुभव करें।"],
      ["अपनी यात्रा शुरू करें", "उपलब्धता पर बात करके उपयुक्त प्रोग्राम चुनें।"],
    ],
    demoEyebrow: "टीचिंग डेमो",
    demoH2: { a: "फैसला करने से पहले", b: "पढ़ाई का ", em: "अनुभव लें।" },
    demoP: "नीचे दिया असली लेक्चर देखें — या सीधे डेमो सेशन बुक करें।",
    demoCta: "बातचीत बुक करें",
    lecturesEyebrow: "वीडियो लाइब्रेरी",
    lecturesH2: { a: "लेक्चर देखें,", b: "कॉन्सेप्ट ", em: "पक्के करें।" },
    lecturesP: "Pranjal Sir Physics चैनल के चुनिंदा लेक्चर — कभी भी, जितनी बार चाहें देखें।",
    lecturesChannel: "पूरा YouTube चैनल देखें ↗",
    enquiryEyebrow: "चलिए फिज़िक्स पर बात करें",
    enquiryH2: { a: "आइए आपके", b: "लक्ष्य ", em: "समझें।" },
    enquiryP: "कुछ जानकारी साझा करें, हमारी टीम उपयुक्त मेंटरशिप प्रोग्राम और डेमो की उपलब्धता पर बात करने के लिए संपर्क करेगी।",
    waNote: "WhatsApp पसंद है?",
    waCta: "टीम से सीधे चैट करें ↗",
    form: {
      title: "अपने बारे में थोड़ा बताएँ",
      req: "* वाले फ़ील्ड अनिवार्य हैं।",
      name: "विद्यार्थी का पूरा नाम *",
      mobile: "मोबाइल नंबर *",
      whatsapp: "WhatsApp नंबर *",
      sameNumber: "मोबाइल नंबर ही WhatsApp है",
      currentClass: "वर्तमान कक्षा *",
      targetExam: "लक्षित परीक्षा *",
      format: "सीखने का फॉर्मेट *",
      challenge: "मुख्य फिज़िक्स चुनौती *",
      contactTime: "संपर्क का पसंदीदा समय *",
      message: "आपका संदेश",
      phName: "आपका नाम",
      phPhone: "10-अंकों का नंबर",
      phMessage: "बताएँ किस चीज़ में मदद चाहिए...",
      selectClass: "कक्षा चुनें",
      classOptions: [["Class 11", "कक्षा 11"], ["Class 12", "कक्षा 12"], ["Dropper", "ड्रॉपर"], ["Other", "अन्य"]],
      selectExam: "परीक्षा चुनें",
      examOptions: [["NEET", "NEET"], ["JEE Main", "JEE मेन"], ["JEE Advanced", "JEE एडवांस्ड"], ["CBSE Boards", "CBSE बोर्ड"], ["ICSE/ISC Boards", "ICSE/ISC बोर्ड"], ["Other", "अन्य"]],
      selectFormat: "फॉर्मेट चुनें",
      formatOptions: [["One-to-One Online Sessions", "वन-टू-वन ऑनलाइन सेशन"], ["Small-Group Classes", "स्मॉल-ग्रुप कक्षाएँ"], ["Need Guidance", "मार्गदर्शन चाहिए"]],
      selectChallenge: "चुनौती चुनें",
      challengeOptions: [["Weak Concepts", "कमज़ोर कॉन्सेप्ट"], ["Difficulty Solving Numericals", "न्यूमेरिकल सॉल्व करने में कठिनाई"], ["Doubt-Solving Support", "डाउट सॉल्विंग सहायता"], ["Board Examination Preparation", "बोर्ड परीक्षा की तैयारी"], ["NEET/JEE Preparation", "NEET/JEE तैयारी"], ["Overall Physics Improvement", "समग्र फिज़िक्स सुधार"]],
      selectTime: "समय चुनें",
      timeOptions: [["Morning", "सुबह"], ["Afternoon", "दोपहर"], ["Evening", "शाम"]],
      consent: "मैं सहमत हूँ कि Pranjal Sir Physics टीम इस पूछताछ के संबंध में मुझसे संपर्क कर सकती है।",
      submit: "मेरा फ्री डेमो बुक करें",
      sending: "आपकी पूछताछ भेजी जा रही है…",
      privacy: "आपकी जानकारी केवल आपकी पूछताछ का उत्तर देने और काउंसलिंग के लिए उपयोग होगी। कोई अपॉइंटमेंट अपने आप कन्फर्म नहीं होती।",
      errPhone: "कृपया मान्य 10-अंकों का भारतीय मोबाइल और WhatsApp नंबर डालें।",
      errConsent: "कृपया पुष्टि करें कि हम इस पूछताछ के बारे में आपसे संपर्क कर सकते हैं।",
      errGeneric: "कुछ गड़बड़ हो गई। आपकी जानकारी यहीं सुरक्षित है — कृपया फिर प्रयास करें।",
    },
    success: { eyebrow: "पूछताछ मिल गई", title: "आपकी रुचि के लिए धन्यवाद।", body: "आपकी पूछताछ मिल गई है। हमारी टीम आपकी लर्निंग ज़रूरतों और डेमो की उपलब्धता पर बात करने के लिए संपर्क करेगी।", ref: "आपका रेफरेंस", wa: "WhatsApp पर चैट करें" },
    faqEyebrow: "सवाल, जवाब सहित",
    faqH2: { a: "शुरू करने से पहले", b: "जानना ", em: "ज़रूरी।" },
    faqItems: [
      ["Pranjal Sir Physics मेंटरशिप कौन जॉइन कर सकता है?", "NEET, JEE और कक्षा 11–12 बोर्ड की तैयारी करने वाले विद्यार्थी उपयुक्त प्रोग्राम के लिए पूछताछ कर सकते हैं।"],
      ["क्या कक्षाएँ ऑनलाइन होती हैं?", "हाँ। मेंटरशिप प्रोग्राम पूरी तरह लाइव ऑनलाइन सीखने पर आधारित हैं।"],
      ["वन-टू-वन फिज़िक्स सेशन क्या होता है?", "यह एक व्यक्तिगत ऑनलाइन सेशन है जो पूरी तरह एक विद्यार्थी के सवालों, कॉन्सेप्ट और ज़रूरतों पर केंद्रित होता है।"],
      ["क्या स्मॉल-ग्रुप कक्षाएँ उपलब्ध हैं?", "चुनिंदा प्रोग्राम में लगभग 5–10 विद्यार्थियों की स्मॉल-ग्रुप कक्षाएँ उपलब्धता के अनुसार मिल सकती हैं।"],
      ["क्या एनरोलमेंट से पहले डेमो बुक कर सकता हूँ?", "आप डेमो रिक्वेस्ट भेज सकते हैं। उपलब्धता और कन्फर्मेशन टीम बताएगी।"],
      ["फीस कितनी है?", "वर्तमान प्रोग्राम विवरण और फीस के लिए कृपया पूछताछ करें।"],
      ["क्या आप NEET और JEE दोनों की फिज़िक्स पढ़ाते हैं?", "प्रोग्राम विवरण के लिए कृपया पूछताछ करें।"],
      ["क्या किसी खास फिज़िक्स अध्याय में मदद मिल सकती है?", "प्रोग्राम विवरण के लिए कृपया पूछताछ करें।"],
    ],
    closingEyebrow: "आपका अगला अध्याय",
    closingH2: { a: "आपकी फिज़िक्स यात्रा", b: "शुरू हो सकती है ", em: "एक बातचीत से।" },
    closingP: "NEET, JEE या बोर्ड — पहला कदम है यह समझना कि आपको कहाँ मदद चाहिए।",
    closingCta: "फ्री डेमो बुक करें",
    footerTag: "उन विद्यार्थियों के लिए व्यक्तिगत फिज़िक्स मेंटरशिप जो रटना नहीं, समझना चाहते हैं।",
    footerAbout: "परिचय",
    footerPrograms: "प्रोग्राम",
    footerContact: "संपर्क",
    rights: "© 2026 Pranjal Sir Physics. सर्वाधिकार सुरक्षित।",
    legal: "प्राइवेसी · शर्तें · कैंसलेशन नीति",
    classroomEyebrow: "स्क्रीन के परे",
    classroomH2: { a: "असली क्लासरूम।", b: "असली ", em: "विद्यार्थी।" },
    classroomP: "ऑनलाइन मेंटरशिप के साथ-साथ — लखनऊ में क्लासरूम सेशन, Doubt Club मीटअप और सेमिनार।",
    classroomCaps: ["विद्यार्थियों की उपलब्धियाँ, साथ मनाई गईं", "जारी लाइव क्लासरूम सेशन", "सेमिनार और डाउट मीटअप"],
    instagramCta: "Instagram पर @pranjal_physics फॉलो करें ↗",
    resultsEyebrow: "वादे नहीं, नतीजे",
    resultsH2: { a: "चयनित विद्यार्थी।", b: "असली ", em: "रैंक।" },
    resultsP: "यहाँ हर सिलेक्शन की शुरुआत एक ईमानदार बातचीत और निरंतर व्यक्तिगत मेंटरशिप से हुई।",
    meterTitle: "अब तक विद्यार्थी मेंटर किए",
    meterNote: "NEET, JEE व बोर्ड बैचेज़ में",
    meterSuffix: "…और आगे भी",
    programWa: (title) => `नमस्ते प्रांजल सर! मुझे ${title} प्रोग्राम में रुचि है। कृपया फीस, टाइमिंग और डेमो की जानकारी साझा करें।`,
    selectedBadge: "चयनित",
    results: [
      { img: "/result-surya.jpg", name: "Surya Pratap Singh", detail: "KGMU 2026 · AIR 2000 · NEET", pos: "center 72%" },
      { img: "/result-krish.jpg", name: "Krish Verma", detail: "KGMC में चयन · NEET", pos: "center 64%" },
    ],
    clips: [
      { src: "/clip-1.mp4", cap: "लाइव लेक्चर — बड़े बोर्ड पर कॉन्सेप्ट" },
      { src: "/clip-2.mp4", cap: "प्रयोगों के साथ फिज़िक्स — लैब डेमो" },
      { src: "/clip-3.mp4", cap: "हमारे क्लासरूम सेशन की झलक" },
    ],
    counters: [
      { to: 500, suffix: "+", label: "विद्यार्थी मेंटर किए", sub: "NEET, JEE व बोर्ड" },
      { to: 10, suffix: "+", label: "वर्षों का शिक्षण", sub: "क्लासरूम व ऑनलाइन" },
      { text: "AIR 2000", label: "सर्वश्रेष्ठ NEET रैंक", sub: "सूर्य प्रताप सिंह, 2026", gold: true },
      { to: 100, suffix: "+", label: "मेडिकल कॉलेज सिलेक्शन", sub: "विभिन्न NEET बैचेज़ में" },
    ],
    reviewLabel: "विद्यार्थी की राय",
    testimonials: [
      { name: "Surya Pratap Singh", detail: "KGMU 2026 · AIR 2000 · NEET", quote: "प्रांजल सर से फिजिक्स पढ़कर मेरे कॉन्सेप्ट काफी अच्छे हुए हैं। पहले जो टॉपिक्स मुश्किल लगते थे, अब उन्हें समझना आसान हो गया है। सर पढ़ाने के साथ-साथ हर डाउट भी क्लियर करते हैं, जिससे फिजिक्स में मेरा कॉन्फिडेंस बढ़ा है।" },
      { name: "Krish Verma", detail: "KGMC में चयन · NEET", quote: "सफलता सिर्फ अच्छे अंक लाने में नहीं, बल्कि खुद पर विश्वास रखने, लगातार मेहनत करने और कभी हार न मानने में है।" },
    ],
    addressLabel: "डाउट क्लब पर आएँ",
    address: "CP-33, अलीगंज, लखनऊ 226024",
    timingLabel: "केंद्र का समय",
    timing: "सुबह 10:00 – रात 8:00",
    waFloat: "हमसे चैट करें",
  },
};
